import { getCurrentYear } from '../utils/getCurrentYear'

const year = getCurrentYear()
export const en = {
  welcome: {
    signIn: 'Sign In',
    signInText:
      'Please check your text or email messages for a secure link to access your account.',
    needHelp: 'Need Help?',
    contactClinic: 'Please contact your care team. For technical questions, contact the ',
    customerSupport: 'Navigating Care support team'
  },
  help: {
    helpTitle: 'Help',
    supportHours: 'Customer Support Hours',
    day: 'Monday – Friday',
    time: '7:00am – 5:00pm (PST)',
    phone: 'Phone',
    email: 'Email',
    FAQ: 'Frequently Asked Questions',
    question1: 'What is Navigating Care?',
    answer1:
      "Navigating Care is a service provided by your clinic that gives you secure access to your personal health information from any smartphone or web-browser device, such as a desktop computer or tablet. With Navigating Care, you'll now have an easy and convenient way to stay connected with your clinic outside of your regularly scheduled appointments.",
    question2: 'Why did I receive a text and/or email message?',
    answer2:
      'Your clinic has partnered with Navigating Care to send you notifications whenever new care information or resources become available for you. Simply click the link within your text or email message to securely access and view personalized information about your health or the care you received from your clinic.',
    question3: 'Is it safe to click the link in the message I received?',
    answer3:
      "Yes! Each link is completely safe and generated uniquely for you. Navigating Care abides by anti-spam requirements in compliance with the U.S. CAN-SPAM Act, meaning you'll never receive a message unless you've agreed to receive notifications from your clinic.",
    question4:
      'Is my personal health information (PHI) secure in Navigating Care?',
    answer4:
      "Your message link and all the information provided is secure and protected. Navigating Care is fully compliant with federal HIPAA and state laws pertaining to your privacy. To prevent any unauthorized access, we require you to verify your identity for each device on which you use Navigating Care - whether it's your phone, desktop, or tablet - before you can gain access to your information.",
    question5: 'Does the link expire?',
    answer5:
      'Yes. For your security, we require you to re-verify your identity every 90 days for each device on which you use Navigating Care. Once verified, you will be able to click on any link previously sent to you to access your information. However, if you choose to sign out of Navigating Care, you will be asked to re-verify your identity the next time you attempt to view your information.',
    question6:
      'What should I do if my personal health information is incorrect?',
    answer6:
      "Navigating Care receives your personal health information directly from your clinic's electronic medical record. If you believe there is an error, please contact your practice directly to update your information.",
    question7: 'Is there a fee to use the service?',
    answer7:
      'No, Navigating Care is a free service provided by your clinic to help you better manage your care. However, standard text messaging rates may apply if you choose to receive messages via your mobile device.',
    question8: 'Who do I contact for technical assistance?',
    answer8: {
      answer:
        'For technical assistance with Navigating Care, please contact the Navigating Care support team at',
      orCall: 'or call',
      time:
        "Monday through Friday, 7AM to 5PM Pacific Time. We'll do our best to help!"
    }
  },
  acceptTerms: {
    title: 'Almost there',
    reviewMessageTitle:
      'Please review the following information about receiving messages from {{clinicName}}.',
    chooseReceiveText:
      'If you choose to receive text messages from Navigating Care, standard carrier message and data rates may apply. Message frequency may vary. For help, text HELP to 82790 or visit',
    moreInformation: 'For more information, view our',
    privacyPolicy: 'Privacy Policy,',
    orSee: 'or see',
    FAQ: 'Frequently Asked Questions',
    texingStop: 'You may opt out of text messages by texting STOP to 82790.',
    acceptingNC: 'By clicking Continue, you are accepting the Navigating Care',
    termsOfUse: 'Terms of Use',
    continue: 'Continue',
    decline: 'I Decline'
  },
  patientConsent: {
    agree: 'Yes, I agree',
    decline: 'I decline'
  },
  confirmSignOut: {
    title: "Are you sure you'd like to sign out?",
    subTitle:
      "Once signed out, you'll need to verify your identity again to view messages from your clinic.",
    staySignIn: 'Stay signed in',
    signOut: 'Sign Out'
  },
  editPreferences: {
    title: 'Preferences',
    mobileNo: 'Mobile Phone Number',
    emailAddress: 'Email Address',
    save: 'Save',
    cancel: 'Cancel'
  },
  listMessages: {
    title: 'Messages'
  },
  start: {
    helthInformation: 'Your health information provided by',
    welcome: 'Welcome',
    verifyInformation:
      'Verify your information to access messages from your clinic.',
    start: 'Start',
    privacyInformation:
      'Your privacy is important to us. For more information please review our',
    termsOfUse: 'Terms of Use',
    and: 'and',
    privactPolicy: 'Privacy Policy'
  },
  termsDeclined: {
    thankYou: 'Thank you',
    subTitle:
      "We will no longer send alerts about this message. If you decide you'd like to access your message, you can still accept terms now, or call our support team.",
    backToTerm: 'Back to Terms',
    sincerely: 'Sincerely,',
    yourCare: 'Your Care Team at'
  },
  tooManyLoginAttempts: {
    oops: 'Too many verification attempts',
    errorMessage:
      'We’ve temporarily blocked access to this service for your security. Please try again in 30 minutes.',
    contactClinic: 'Contact your clinic or support program for help logging in.',
    mainPhone: 'Main Office Phone',
    nc: 'Navigating Care',
    customerSupport: 'Customer Support',
    day: 'Monday – Friday',
    time: '7:00am – 5:00pm (PST)',
    email: 'Email',
    phone: 'Phone'
  },
  verify: {
    verifyPatientInformation: 'Verify patient information',
    verifyBirthdate: "Verify patient's date of birth to get started",
    firstName: 'First Name',
    lastName: 'Last Name',
    DOB: 'Date of Birth',
    invalidDob: 'Date of birth must be a valid date.',
    month: 'Month',
    day: 'Day',
    year: 'Year',
    yearPlaceholder: 'YYYY',
    zipCode: 'Zip Code',
    validationMessage: 'Enter your 5-digit zip code.',
    verify: 'Verify',
    errorTitle: "Oops! Something didn't match up",
    errorMessage:
      'After five attempts, access to this service will be blocked. For help, <0>contact your clinic</0>.',
    aboutTitle: 'About Navigating Care',
    aboutDescription:
      'Your clinic uses Navigating Care to provide services to help you stay connected with your care team.',
    privacyPolicy:
      'Your privacy is important to us. For more information, review our <0>Terms of Use</0> and <1>Privacy Policy</1>.',
    dobRequired: 'Date of birth is required.',
    yearDigits: 'Year must be four digits.',
    digitalCompanion: 'Your digital health companion for',
    rememberMe:
      'Remember me on this device for 60 days. Uncheck if on a public device.'
  },
  viewMessages: {
    successMessage:
      'Success! You are ready to view messages from {{clinicName}}.',
    messages: 'Messages',
    backToTop: 'Back to top'
  },
  viewPreferences: {
    title: 'Preferences',
    mobileNo: 'Mobile Phone Number',
    emailAddress: 'Email Address',
    edit: 'Edit'
  },
  yourClinic: {
    title: 'Your Clinic',
    viewOnMap: 'View on Map',
    phone: 'Phone'
  },
  about: {
    title: 'About Us',
    detail:
      'Navigating Care delivers messages from your clinic and other resources to assist with your health care.'
  },
  errorMessage: {
    title: 'Oops, something went wrong.',
    error:
      "We're sorry, but this page is not available right now. Please try again later.",
    errorCode: 'Error code {{code}}'
  },
  footer: {
    about: 'About',
    help: 'Help',
    termsOfUse: 'Terms of Use',
    privacyPolicy: 'Privacy Policy',
    englishSelect: 'English',
    spanishSelect: 'Spanish'
  },
  layoutWrapper: {
    messages: 'Messages',
    yourClinic: 'Your Clinic',
    preferences: 'Preferences',
    signOut: 'Sign Out',
    help: 'Help'
  },
  common: {
    nc: 'Navigating Care',
    copy: `© ${year} Navigating Care, Inc`,
    url: '',
    phone: '1-800-925-4456',
    supportEmail: 'support@navigatingcare.com',
    infoEmail: 'info@navigatingcancer.com'
  }
}
export type Translation = typeof en
